import React, { useCallback, useEffect, useState, useMemo, SetStateAction } from 'react';
import {
  Box,
  ButtonBase,
  Button,
  Card,
  IconButton,
  Drawer,
  List,
  Paper,
  CircularProgress,
  Container,
  Typography,
  Chip,
  Modal,
  Fade,
  Backdrop,
} from '@material-ui/core';
import { Close, Launch } from '@material-ui/icons';
import { LatLngBoundsLiteral, LatLngTuple } from 'leaflet';
import { saveAs } from 'file-saver';
import { useHistory, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Viewport } from 'react-leaflet';
import { optionStyles } from './styles';
import LeftArrow from '../../assets/leftArrow.svg';
import MapContent from '../../components/MapContent';
import FilterBar, { IncFilterOpsType } from '../../components/FilterBar';
import ChartGenerator from '../../components/ChartsGenerator';
import { DrawPolygonType } from '../../components/MapContent';
import {
  chartDataObject,
  toddowChartDataObject,
  mapInformationChartDataObject,
  tableChartDataObject,
} from '../../@types/chartData';
import { IChartState } from '../../store/modules/chart/types';
import { addChartsToExport } from '../../store/modules/chart/action';
import { jsonb as JsonbType } from '../../@types/jsonb';
import { getFilterDates } from '../../actions/managementActions';
import {
  fetchIncidentsTileKey,
  getFullZip,
  getInformationChartData,
  getSimplifiedZip,
} from '../../actions/incidentActions';
import { ChatVerbeux } from '../ChatVerbeux';

interface TableData {
  rows: tableChartDataObject[];
  legends: string[];
}

const initialJsonb: JsonbType = {
  jsonb: {
    driverVeiculo: {
      'Tipo Veículo': {
        _rule_type: 'containment_multiple',
        contains: [],
      },
    },
    driverIncidenteDetails: {
      Natureza: {
        _rule_type: 'containment',
        contains: [],
      },
      Severidade: {
        _rule_type: 'containment',
        contains: [],
      },
    },
  },
};

const initialFilterOps: IncFilterOpsType = {
  endDate: '',
  startDate: '',
  veiculos: [],
  gravidades: [],
  location: [],
  tipoAcidentes: [],
  bairros: '',
  vias: '',
  regionais: '',
  drawPolygon: {},
};

const loadFilterOps = (): IncFilterOpsType => {
  let filterOpsObj: IncFilterOpsType = initialFilterOps;
  const loadedFilterOps = localStorage.getItem('incFilterOps');

  if (loadedFilterOps) {
    filterOpsObj = JSON.parse(loadedFilterOps);
  }

  return filterOpsObj;
};

const loadJsonbStorage = (): JsonbType => {
  const loadedFilterOps = localStorage.getItem('incFilterOps');
  let jsonbObj: JsonbType = initialJsonb;

  if (loadedFilterOps) {
    const parsedFilters: IncFilterOpsType = JSON.parse(loadedFilterOps);

    const vehicles: Array<string | string[]> = [];
    const gravity: Array<string | string[]> = [];
    const nature: Array<string | string[]> = [];

    parsedFilters.veiculos.map((item) => {
      vehicles.push(item);
      vehicles.push([item]);
    });

    parsedFilters.gravidades.map((item) => {
      gravity.push(item);
      gravity.push([item]);
    });

    parsedFilters.tipoAcidentes.map((item) => {
      nature.push(item);
      nature.push([item]);
    });

    jsonbObj = {
      jsonb: {
        driverVeiculo: {
          'Tipo Veículo': {
            _rule_type: 'containment_multiple',
            contains: vehicles,
          },
        },
        driverIncidenteDetails: {
          Natureza: {
            _rule_type: 'containment',
            contains: nature,
          },
          Severidade: {
            _rule_type: 'containment',
            contains: gravity,
          },
        },
      },
    };

    return jsonbObj;
  }
  return jsonbObj;
};

const MapIncidents: React.FC = () => {
  const history = useHistory<{ viewport: string }>();

  const viewportSettings = useMemo<Viewport | undefined>(() => {
    if (history.location.state) {
      const loadeSettins = JSON.parse(history.location.state.viewport);
      return loadeSettins;
    }
    return undefined;
  }, [history.location.state]);

  const dispatch = useDispatch();
  const defaultStartDate = `${process.env.REACT_APP_MAP_START_DEFAULT_DATE}`;
  const defaultEndDate = `${process.env.REACT_APP_MAP_END_DEFAULT_DATE}`;
  const classes = optionStyles();
  const [openMenu, setOpenMenu] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingFileDownload, setLoadingFileDownload] = useState<boolean>(false);
  const [loading0, setLoading0] = useState<boolean>(true);
  const [loading1, setLoading1] = useState<boolean>(true);
  const [loading2, setLoading2] = useState<boolean>(true);
  const [loading3, setLoading3] = useState<boolean>(true);
  const [loading4, setLoading4] = useState<boolean>(true);
  const [loading5, setLoading5] = useState<boolean>(true);
  const [loading6, setLoading6] = useState<boolean>(true);
  const [loading7, setLoading7] = useState<boolean>(true);
  const [loading8, setLoading8] = useState<boolean>(true);
  const [openTable, setOpenTable] = useState<boolean>(true);
  const [openTableResp, setOpenTableResp] = useState<boolean>(false);

  const [legendY1, setLegendY1] = useState<string>('');
  const [legendY2, setLegendY2] = useState<string>('');
  const [legendY3, setLegendY3] = useState<string>('');
  const [legendY4, setLegendY4] = useState<string>('');
  const [chartPerfilVitima, setChartPerfilVitima] = useState<tableChartDataObject[]>([]);
  const [toddowChart, setToddowChart] = useState<toddowChartDataObject[]>([]);
  const [mapInformationChart, setMapInformationChart] = useState<
    mapInformationChartDataObject[]
  >([]);
  const [intervalAgeChart, setIntervalAgeChart] = useState<chartDataObject[]>([]);
  const [genderVictimChart, setGenderVictimChart] = useState<chartDataObject[]>([]);
  const [victimTypeChart, setVictimTypeChart] = useState<chartDataObject[]>([]);
  const [runOverChart, setRunOverChart] = useState<chartDataObject[]>([]);
  const [stepwiseChart, setStepwiseChart] = useState<chartDataObject[]>([]);
  const [timerangeChart, setTimerangeChart] = useState<chartDataObject[]>([]);
  const [sinisterByYear, setSinisterByYear] = useState<chartDataObject[]>([]);

  const [collisionTypeChart, setCollisionTypeChart] = useState<chartDataObject[]>([]);
  const [jsonb, setJsonb] = useState<JsonbType>(loadJsonbStorage());
  const [dateMin, setDateMin] = useState<string>(defaultStartDate);
  const [dateMax, setDateMax] = useState<string>(defaultEndDate);
  const [position, setPosition] = React.useState<LatLngTuple>([0, 0]);
  const [zoom, setZoom] = useState<number>(0);
  const [boundary_polygon, setBoundary_polygon] = useState<{}>({});
  const [bboxPolygon, setBboxPolygon] = useState<LatLngBoundsLiteral>([
    [0, 0],
    [0, 0],
  ]);
  const [startDateMap, setStartDateMap] = useState<string>('2014-01-01T00:00:00Z');
  const [endDateMap, setEndDateMap] = useState<string>('2020-06-30T23:59:59.999000Z');
  const [drawPolygon, setDrawPolygon] = useState<DrawPolygonType | {}>(
    loadFilterOps().drawPolygon,
  );
  const [address, setAddress] = useState<string>('');
  const [requester, setRequester] = useState<string>('');

  const [filterVehicles, setFilterVehicles] = useState<string[]>([]);

  const [generalDate, setGeneralDate] = useState<string>('');
  const [fatalDate, setFatalDate] = useState<string>('');
  const [loadingDate, setloadingDate] = useState<boolean>(true);
  const tableData: TableData = {
    rows: chartPerfilVitima,
    legends: [
      'Gênero',
      'Ocupante de 4 rodas',
      'Ocupante de 2 rodas',
      'Ciclista',
      'Pedestre',
      'Outros',
      'Não Inf.',
      'Total',
    ],
  };

  const filterOps: IncFilterOpsType = loadFilterOps();

  // const locations = filterOps.location;
  // const result = locations.join(',');

  const params = useMemo(() => {
    return {
      archived: 'False',
      occurred_min: filterOps.startDate || dateMin,
      occurred_max: filterOps.endDate || dateMax,
      // location: result,
      ...jsonb,
      ...drawPolygon,
      ...boundary_polygon,
    };
  }, [
    boundary_polygon,
    drawPolygon,
    jsonb,
    dateMin,
    dateMax,
    filterOps.startDate,
    filterOps.endDate,
  ]);

  function formatDatetimeToDate(date: string) {
    const datePart = date.split('T')[0];
    const dateArray = datePart.split('-');
    return `${dateArray[2]}/${dateArray[1]}/${dateArray[0].slice(2)}`;
  }

  const fetchManagementDate = useCallback(async () => {
    setloadingDate(true);
    try {
      const dates = await getFilterDates(filterOps.startDate, filterOps.endDate);
      setDateMin(dates.dateMin);
      setDateMax(dates.dateMax);
      setStartDateMap(dates.startDateMap);
      setEndDateMap(dates.endDateMap);
      setFatalDate(formatDatetimeToDate(dates.fatalDate));
      setGeneralDate(formatDatetimeToDate(dates.generalDate));
    } catch (error) {
      console.log(error);
    } finally {
      setloadingDate(false);
    }
  }, [filterOps.startDate, filterOps.endDate]);

  const fetchMapInformationChartData = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await getInformationChartData({
        params,
      });
      setMapInformationChart(data);
    } catch (error) {
      setMapInformationChart([]);
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    fetchManagementDate();
  }, [drawPolygon, fetchManagementDate]);

  useEffect(() => {
    if (!loadingDate) {
      fetchMapInformationChartData();
    }
  }, [loadingDate, fetchMapInformationChartData]);

  // exportador
  const names: IChartState = {
    charts: [
      {
        img: 'HeatMap',
        name: 'Ocorrências por faixa de horário e dia da semana',
        chartType: 'heat',
        heat: toddowChart,
      },
      {
        img: 'LineChartIcon',
        name: 'Ocorrências por dia da semana',
        chartType: 'line',
        chart: stepwiseChart,
        legendY: '',
        legendTwo: 'Totais',
        legendOne: 'Com vítimas',
      },
      {
        img: 'LineChartIcon',
        name: 'Ocorrências por faixa de horário',
        chartType: 'line',
        legendY: '',
        legendTwo: 'Totais',
        legendOne: 'Com vítimas',
        chart: timerangeChart,
      },
      {
        img: 'BarChartHorizontalIcon',
        name: 'Tipologia das ocorrências',
        chartType: 'barh',
        legendY: '',
        legendOne: ' ',
        percent: false,
        chart: collisionTypeChart,
      },
      {
        img: 'BarChartHorizontalIcon',
        name: 'Veículos envolvidos nas ocorrências',
        chartType: 'barh',
        legendY: '',
        legendOne: ' ',
        percent: true,
        chart: runOverChart,
      },
      {
        img: 'BarChartHorizontalIcon',
        name: 'Perfil dos usuários envolvidos por severidade',
        chartType: 'barh',
        legendY: '',
        legendTwo: 'Fatal',
        legendOne: 'Ferido',
        percent: true,
        chart: victimTypeChart,
      },
      {
        img: 'BarChartHorizontalIcon',
        name: 'Gênero dos usuários envolvidos por severidade',
        chartType: 'barh',
        legendY: '',
        legendTwo: 'Fatal',
        legendOne: 'Ferido',
        percent: true,
        chart: genderVictimChart,
      },
      {
        img: 'BarChartVerticalIcon',
        name: 'Faixa etária dos usuários envolvidos por severidade',
        chartType: 'barv',
        legendY: '',
        legendTwo: 'Fatal',
        legendOne: 'Ferido',
        percent: true,
        chart: intervalAgeChart,
      },
      {
        img: 'TableIcon',
        name: 'Perfil dos usuários envolvidos por gênero e veículo associado',
        chartType: 'table',
        table: tableData,
      },
    ],
  };

  const handleAddChartsToExport = useCallback(
    (charts: IChartState) => {
      dispatch(addChartsToExport(charts));
      history.push('/exportador');
    },
    [dispatch, history],
  );

  const handleSimplifiedExport = useCallback(async () => {
    setLoadingFileDownload(true);
    try {
      const { data } = await getSimplifiedZip({ params });
      saveAs(data, 'exportSimplificada.zip');
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingFileDownload(false);
    }
  }, [params]);

  const handleFullExport = useCallback(async () => {
    setLoadingFileDownload(true);
    try {
      const { data } = await getFullZip({ params });
      saveAs(data, 'exportCompleta.zip');
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingFileDownload(false);
    }
  }, [params]);

  return (
    <>
      <FilterBar
        filterJson={setJsonb}
        dateMinSet={setDateMin}
        dateMaxSet={setDateMax}
        filterVehicles={setFilterVehicles}
        setPositionSearch={setPosition}
        zoom={setZoom}
        id_boundary={setBoundary_polygon}
        bbox_boundary={setBboxPolygon}
        routeTo="sinistro"
        startDateMap={startDateMap}
        endDateMap={endDateMap}
        drawPolygon={drawPolygon}
        setDrawPolygon={setDrawPolygon}
        address={address}
        setAddress={setAddress}
        requester={requester}
        setRequester={setRequester}
      />
      <Container className={classes.responsiveButton}>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={loadingFileDownload}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={loadingFileDownload}>
            <div className={classes.loadingContainer}>
              <CircularProgress
                className={classes.loadingSpinner}
                size={60}
                thickness={5}
              />
            </div>
          </Fade>
        </Modal>
        <Chip
          title="Mapa de Sinistros"
          label="Mapa de Sinistros"
          className={classes.pageNameChip}
        />
        <ButtonBase
          className={`${classes.responsivemenuButton} ${
            openMenu === 1 ? classes.btnSelected : ''
          }`}
          onClick={() => {
            setOpenMenu(openMenu === 1 ? 0 : 1);
          }}
        >
          Gráficos
        </ButtonBase>
        <ButtonBase
          className={`${classes.responsivemenuButton} ${
            openMenu === 2 ? classes.btnSelected : ''
          }`}
          onClick={() => setOpenMenu(openMenu === 2 ? 0 : 2)}
        >
          Exportar
        </ButtonBase>
        <ButtonBase
          className={`${classes.responsivemenuButton} ${
            openMenu === 3 ? classes.btnSelected : ''
          }`}
          onClick={() => setOpenMenu(openMenu === 3 ? 0 : 3)}
        >
          Download CSV
        </ButtonBase>

        <ButtonBase
          className={`${classes.responsivemenuButton} ${
            openMenu === 4 ? classes.btnSelected : ''
          }`}
          onClick={() => setOpenMenu(openMenu === 4 ? 0 : 4)}
        >
          Relatórios Anuais
        </ButtonBase>
        <a
          href="https://bit.ly/consulta-pst"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'none', width: '100%' }}
        >
          <Button
            style={{ textTransform: 'none' }}
            className={classes.responsivemenuButton}
            endIcon={<Launch />}
          >
            Plano de Segurança no Trânsito
          </Button>
        </a>
        <ButtonBase
          onClick={() => {
            openTableResp ? setOpenTableResp(false) : setOpenTableResp(true);
          }}
          className={`${classes.responsivemenuButton} ${
            openTableResp ? classes.tableOpen : classes.tableClosed
          }`}
        >
          <img
            className={classes.tableButonIcon}
            src={LeftArrow}
            alt="Right"
            style={{ transform: `${openTableResp ? 'rotate(0deg)' : 'rotate(180deg)'}` }}
          />
          {openTableResp ? (
            <>
              <Typography variant="h6" className={classes.tableText}>
                Fechar aba lateral
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h6" className={classes.tableText}>
                Abrir aba lateral
              </Typography>
            </>
          )}
        </ButtonBase>
      </Container>
      <div>
        <MapContent
          pageName="Sinistros"
          occurred_min={dateMin}
          occurred_max={dateMax}
          jsonb={jsonb}
          polygon={setDrawPolygon}
          positionSearch={position}
          zoomSearch={zoom}
          polygon_id={boundary_polygon}
          bbox={bboxPolygon}
          type={`${process.env.REACT_APP_INC_RECORD_TYPE}`}
          apiName="sinistro"
          registerName="Sinistros"
          loadingMap={loadingDate}
          viewport={viewportSettings}
          config={{ params }}
          fetchTileKeyRequest={fetchIncidentsTileKey}
        />
      </div>

      <>
        <Box
          className={`${classes.tableButton} ${
            openTable ? classes.tableOpen : classes.tableClosed
          }`}
        >
          <IconButton
            className={classes.button}
            onClick={() => {
              if (openTable) {
                setOpenTable(false);
              } else {
                const chatContainer = document.getElementById('chatContainer');
                if (chatContainer) {
                  if (chatContainer.classList.contains('open')) {
                    chatContainer.classList.remove('open');
                    setTimeout(() => {
                      chatContainer.style.display = 'none';
                    }, 300);
                  }
                }
                setOpenTable(true);
              }
            }}
          >
            <img className={classes.tableButonIcon} src={LeftArrow} alt="Right" />
          </IconButton>
        </Box>
        <Drawer
          anchor="right"
          open={openTable}
          variant="persistent"
          ModalProps={{ BackdropProps: { invisible: true } }}
          PaperProps={{ className: classes.tableDrawer }}
        >
          {loading ? (
            <div className={classes.loadingContainer}>
              <CircularProgress
                className={classes.loadingSpinner}
                size={60}
                thickness={5}
              />
            </div>
          ) : (
            // Informações totais no card lateral com base na filtragem
            <List>
              {mapInformationChart.map((obj) => (
                <Paper className={classes.accidentCard} key={`${obj.label} ${obj.value}`}>
                  <Box className={classes.accidentLabel}>{obj.label}</Box>
                  <Box className={classes.accidentValue}>
                    {obj.value.toLocaleString('pt-BR')}
                  </Box>
                </Paper>
              ))}
              {/* <Paper className={classes.accidentCard} key={`${generalDate} ${fatalDate}`}>
                <Box className={classes.accidentLabel}>Dados consolidados</Box>
                <Box className={classes.accidentValue}>Geral: {generalDate}</Box>
                <Box className={classes.accidentValue}>Fatais: {fatalDate}</Box>
              </Paper> */}
            </List>
          )}
        </Drawer>
        <Drawer
          anchor="right"
          open={openTableResp}
          variant="persistent"
          ModalProps={{ BackdropProps: { invisible: true } }}
          PaperProps={{ className: classes.tableDrawerResp }}
        >
          {loading ? (
            <div className={classes.loadingContainer}>
              <CircularProgress
                className={classes.loadingSpinner}
                size={60}
                thickness={5}
              />
            </div>
          ) : (
            <List>
              {mapInformationChart.map((obj) => (
                <Paper className={classes.accidentCard} key={`${obj.label} ${obj.value}`}>
                  <Box className={classes.accidentLabel}>{obj.label}</Box>
                  <Box className={classes.accidentValue}>{obj.value}</Box>
                </Paper>
              ))}
            </List>
          )}
        </Drawer>
      </>
      {/* Gráficos do Mapa */}
      <Box className={classes.footerMenu}>
        {openMenu === 1 && (
          <Card className={classes.chartsMenu} elevation={0}>
            <Button
              onClick={() => setOpenMenu(0)}
              className={classes.buttonCloseResponsive}
            >
              Fechar
            </Button>
            {/* Gráficos do Mapa */}
            <div style={{ display: 'flex', backgroundColor: 'transparent' }}>
              <ChartGenerator
                params={params}
                charts={[
                  {
                    title: 'Ocorrências por faixa de horário e dia da semana',
                    chartType: 'heat',
                    heat: toddowChart,
                    request: 'incident_records/toddow',
                    setChart: setToddowChart,
                    loading: loading0,
                    setLoading: setLoading0,
                    setlegend: setLegendY1,
                  },
                  {
                    title: 'Ocorrências por dia da semana',
                    chartType: 'line',
                    legendY: '',
                    legendTwo: 'Com vítimas',
                    legendOne: 'Totais',
                    chart: stepwiseChart,
                    request: 'incident_records/stepwise',
                    setChart: setStepwiseChart,
                    loading: loading1,
                    setLoading: setLoading1,
                    setlegend: setLegendY1,
                  },
                  {
                    title: 'Ocorrências por faixa de horário',
                    chartType: 'line',
                    legendY: '',
                    legendTwo: 'Com vítimas',
                    legendOne: 'Totais',
                    chart: timerangeChart,
                    request: 'incident_records/chart_timerange',
                    setChart: setTimerangeChart,
                    loading: loading2,
                    setLoading: setLoading2,
                    legend: true,
                    setlegend: setLegendY1,
                  },
                  {
                    title: 'Sinistros por ano',
                    chartType: 'line',
                    legendY: ' ',
                    legendTwo: ' ',
                    legendOne: 'Sinistros',
                    chart: sinisterByYear,
                    request: 'incident_records/chart_sinister_by_year',
                    setChart: setSinisterByYear,
                    loading: loading8,
                    setLoading: setLoading8,
                    setlegend: setLegendY1,
                  },
                  {
                    title: 'Tipologia das ocorrências',
                    chartType: 'barh',
                    legendY: legendY2,
                    percent: true,
                    chart: collisionTypeChart,
                    request: 'incident_records/chart_natureza',
                    setChart: setCollisionTypeChart,
                    loading: loading3,
                    setLoading: setLoading3,
                    legend: true,
                    setlegend: setLegendY2,
                  },
                  {
                    title: 'Veículos envolvidos em atropelamento',
                    chartType: 'barh',
                    legendY: legendY3,
                    percent: true,
                    chart: runOverChart,
                    request: 'incident_records/chart_atropelamento',
                    setChart: setRunOverChart,
                    loading: loading4,
                    setLoading: setLoading4,
                    legend: true,
                    setlegend: setLegendY3,
                  },
                  {
                    title: 'Perfil dos usuários envolvidos por severidade',
                    chartType: 'barh',
                    legendY: ' ',
                    legendTwo: 'Fatal',
                    legendOne: 'Ferido',
                    percent: true,
                    chart: victimTypeChart,
                    request: 'incident_records/chart_tipovitima',
                    setChart: setVictimTypeChart,
                    loading: loading5,
                    setLoading: setLoading5,
                    setlegend: setLegendY1,
                  },
                  {
                    title: 'Gênero dos usuários envolvidos por severidade',
                    chartType: 'barh',
                    legendY: legendY4,
                    legendTwo: 'Fatal',
                    legendOne: 'Ferido',
                    percent: true,
                    chart: genderVictimChart,
                    request: 'incident_records/chart_generovitima',
                    setChart: setGenderVictimChart,
                    loading: loading6,
                    setLoading: setLoading6,
                    legend: true,
                    setlegend: setLegendY4,
                  },
                  {
                    title: 'Faixa etária dos usuários envolvidos por severidade',
                    chartType: 'barv',
                    legendY: ' ',
                    legendTwo: 'Fatal',
                    legendOne: 'Ferido',
                    percent: true,
                    chart: intervalAgeChart,
                    request: 'incident_records/chart_generoidadevitima',
                    setChart: setIntervalAgeChart,
                    loading: loading7,
                    setLoading: setLoading7,
                    setlegend: setLegendY1,
                  },
                ]}
              />
              <IconButton onClick={() => setOpenMenu(0)} className={classes.buttonClose}>
                <Close />
              </IconButton>
            </div>
          </Card>
        )}

        {openMenu === 2 && (
          <Card className={classes.exportPalette} elevation={0} style={{ left: 103 }}>
            <Button
              variant="outlined"
              className={`${classes.buttonPalette} ${classes.cancel}`}
              onClick={() => setOpenMenu(0)}
            >
              Fechar
            </Button>
            <Button
              variant="outlined"
              type="button"
              className={classes.buttonPalette}
              onClick={() => {
                handleAddChartsToExport(names);
              }}
            >
              PDF
            </Button>
            <Button
              variant="outlined"
              type="button"
              onClick={handleSimplifiedExport}
              className={classes.buttonPalette}
            >
              Exportação simplificada
            </Button>
            <Button
              onClick={handleFullExport}
              variant="outlined"
              type="button"
              className={classes.buttonPalette}
            >
              Exportação completa
            </Button>
          </Card>
        )}
        {openMenu === 3 && (
          <Card className={classes.exportPalette} elevation={0} style={{ left: 210 }}>
            <Typography style={{ padding: '5px 10px', textAlign: 'center' }}>
              CSV
            </Typography>
            <Button
              variant="outlined"
              className={`${classes.buttonPalette} ${classes.cancel}`}
              onClick={() => setOpenMenu(0)}
            >
              Fechar
            </Button>
            <Link
              to="/files/Sinistros_2015.xls"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2015
              </Button>
            </Link>
            <Link
              to="/files/Sinistros_2016.xls"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2016
              </Button>
            </Link>
            <Link
              to="/files/Sinistros_2017.xls"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2017
              </Button>
            </Link>
            <Link
              to="/files/Sinistros_2018.xls"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2018
              </Button>
            </Link>
            <Link
              to="/files/Sinistros_2019.xls"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2019
              </Button>
            </Link>
            <Link
              to="/files/Sinistros_2020.xlsx"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2020
              </Button>
            </Link>
          </Card>
        )}
        {openMenu === 4 && (
          <Card className={classes.exportPalette} elevation={0} style={{ left: 360 }}>
            <Typography style={{ padding: '5px 10px', textAlign: 'center' }}>
              Relatórios Anuais
            </Typography>
            <Button
              variant="outlined"
              className={`${classes.buttonPalette} ${classes.cancel}`}
              onClick={() => setOpenMenu(0)}
            >
              Fechar
            </Button>
            <Link
              to="/files/annual_reports/Relatório Anual de Segurança Viária 2015.pdf"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2015
              </Button>
            </Link>
            <Link
              to="/files/annual_reports/Relatório Anual de Segurança Viária 2016.pdf"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2016
              </Button>
            </Link>
            <Link
              to="/files/annual_reports/Relatório Anual de Segurança Viária 2017.pdf"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2017
              </Button>
            </Link>
            <Link
              to="/files/annual_reports/Relatório Anual de Segurança Viária 2018.pdf"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2018
              </Button>
            </Link>
            <Link
              to="/files/annual_reports/Relatório Anual de Segurança Viária 2019.pdf"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2019
              </Button>
            </Link>
            <Link
              to="/files/annual_reports/Relatório Anual de Segurança Viária 2020.pdf"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2020
              </Button>
            </Link>
            <Link
              to="/files/annual_reports/Relatório Anual de Segurança Viária 2021.pdf"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2021
              </Button>
            </Link>
            <Link
              to="/files/annual_reports/Relatório Anual de Segurança Viária 2022.pdf"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2022
              </Button>
            </Link>
            <Link
              to="/files/annual_reports/Relatório Anual de Segurança Viária 2023.pdf"
              target="_blank"
              download
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outlined" type="button" className={classes.buttonPalette}>
                2023
              </Button>
            </Link>
          </Card>
        )}

        <ButtonBase
          className={`${classes.menuButton} ${
            openMenu === 1 ? classes.footerMenuActive : ''
          }`}
          onClick={() => {
            setOpenMenu(openMenu === 1 ? 0 : 1);
          }}
        >
          Gráficos
        </ButtonBase>
        <ButtonBase
          className={`${classes.menuButton} ${
            openMenu === 2 ? classes.footerMenuActive : ''
          }`}
          onClick={() => setOpenMenu(openMenu === 2 ? 0 : 2)}
        >
          Exportar
        </ButtonBase>
        <ButtonBase
          className={`${classes.menuButton} ${
            openMenu === 3 ? classes.footerMenuActive : ''
          }`}
          onClick={() => setOpenMenu(openMenu === 3 ? 0 : 3)}
        >
          Download CSV
        </ButtonBase>
        <ButtonBase
          className={`${classes.menuButton} ${
            openMenu === 4 ? classes.footerMenuActive : ''
          }`}
          onClick={() => setOpenMenu(openMenu === 4 ? 0 : 4)}
        >
          Relatórios Anuais
        </ButtonBase>
        <a
          href="https://bit.ly/PMSTFOR"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <Button className={classes.menuButton} endIcon={<Launch />}>
            Plano de Segurança no Trânsito
          </Button>
        </a>
      </Box>
      {/* <ChatVerbeux setSummaryOpen={setOpenTable} /> */}
    </>
  );
};

export default MapIncidents;
